import { ProductCategory, ProductOrder, ProductType, AllProducts } from 'models/store';

import { api } from '..';
import {
  AddAccounts,
  AddProductType,
  BuyProduct,
  FetchProductTypes,
  FetchProducts,
  FetchStoreOrders,
  FetchOneOrder,
  EditAccount,
  EditProductType,
  FetchOneProductCategory,
} from './store';

export const storeApi = api.injectEndpoints({
  endpoints: (build) => ({
    fetchProductCategories: build.query<ProductCategory[], void>({
      query: () => ({
        url: `/store/categories`,
      }),
      transformResponse: (rawResult: { data: ProductCategory[] }) => {
        return rawResult.data;
      },
      providesTags: ['Store'],
    }),
    fetchOneProductCategory: build.query<Omit<ProductCategory, 'types'>, FetchOneProductCategory>({
      query: (id) => ({
        url: `/store/categories/${id}`,
      }),
      transformResponse: (rawResult: { data: Omit<ProductCategory, 'types'> }) => {
        return rawResult.data;
      },
      providesTags: ['Store'],
    }),
    fetchProductTypes: build.query<ProductType[], FetchProductTypes>({
      query: ({ ...params }) => ({
        url: `/store/types`,
        params,
      }),
      transformResponse: (rawResult: { data: ProductType[] }) => {
        return rawResult.data;
      },
      providesTags: ['Store'],
    }),
    fetchOrders: build.query<ProductOrder[], FetchStoreOrders>({
      query: ({ ...params }) => ({
        url: `/store/orders`,
        params,
      }),
      transformResponse: (rawResult: { data: ProductOrder[] }) => {
        return rawResult.data;
      },
      providesTags: ['Store'],
    }),
    fetchOneOrder: build.query<ProductOrder, FetchOneOrder>({
      query: (id) => ({
        url: `/store/orders/${id}`,
      }),
      transformResponse: (rawResult: { data: ProductOrder }) => {
        return rawResult.data;
      },
      providesTags: ['Store'],
    }),
    fetchProducts: build.query<AllProducts, FetchProducts>({
      query: ({ categoryId, ...params }) => ({
        url: `/store/products/${categoryId}`,
        params,
      }),
      transformResponse: (rawResult: { data: AllProducts }) => {
        return rawResult.data;
      },
      providesTags: ['Store'],
    }),
    addProductType: build.mutation<void, AddProductType>({
      query: (body) => ({
        url: `/store/types`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Store'],
    }),
    addAccounts: build.mutation<void, AddAccounts>({
      query: (body) => ({
        url: `/store/accounts`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Store'],
    }),
    updateAccount: build.mutation<void, EditAccount>({
      query: ({ id, ...body }) => ({
        url: `/store/accounts/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Store'],
    }),
    updateProductType: build.mutation<void, EditProductType>({
      query: ({ id, ...body }) => ({
        url: `/store/types/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Store'],
    }),
    buyProducts: build.mutation<void, BuyProduct>({
      query: (body) => ({
        url: `/store/buy`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Store'],
    }),
  }),
});
